<div class="delivery-rate-policy-page">
    <h2>Delivery Rate Policy</h2>
    <p class="page-helper">
        These global values control the allowed courier delivery rates and the checkout delivery options
        (Santiago / DR launch controls). Changes affect new checkout estimates and new courier rate saves.
        They do not rewrite existing orders.
    </p>
    <p class="page-helper" data-testid="rate-policy-global-note">
        These are fixed global rails set by TinyAll — they are not a computed market average. Market-mean
        pricing is a planned future phase.
    </p>

    <p-progressSpinner *ngIf="isLoading" styleClass="page-spinner"></p-progressSpinner>

    <ng-container *ngIf="!isLoading">
        <div class="policy-meta" *ngIf="policy" data-testid="rate-policy-meta">
            <span><b>Policy version:</b> {{ policy.policyVersion }}</span>
            <span><b>Source:</b> {{ policy.source === 'DATABASE' ? 'Admin-saved' : 'Config defaults (not saved yet)' }}</span>
            <span *ngIf="policy.updatedAt"><b>Last updated:</b> {{ policy.updatedAt | date:'medium' }}</span>
            <span *ngIf="policy.updatedBy"><b>Updated by:</b> {{ policy.updatedBy }}</span>
            <span *ngIf="policy.changeReason"><b>Last change reason:</b> {{ policy.changeReason }}</span>
        </div>

        <p-card header="First kilometer (RD$)" styleClass="settings-card">
            <div class="rate-fields">
                <div class="field-column">
                    <label for="firstKmMin">Minimum</label>
                    <input id="firstKmMin" data-testid="first-km-min" pInputText type="number" min="1"
                        [(ngModel)]="firstKmMin" />
                </div>
                <div class="field-column">
                    <label for="firstKmDefault">Recommended</label>
                    <input id="firstKmDefault" data-testid="first-km-default" pInputText type="number" min="1"
                        [(ngModel)]="firstKmDefault" />
                </div>
                <div class="field-column">
                    <label for="firstKmMax">Maximum</label>
                    <input id="firstKmMax" data-testid="first-km-max" pInputText type="number" min="1"
                        [(ngModel)]="firstKmMax" />
                </div>
            </div>
        </p-card>

        <p-card header="Additional kilometers (RD$ per km)" styleClass="settings-card">
            <div class="rate-fields">
                <div class="field-column">
                    <label for="additionalKmMin">Minimum</label>
                    <input id="additionalKmMin" data-testid="additional-km-min" pInputText type="number" min="0"
                        [(ngModel)]="additionalKmMin" />
                </div>
                <div class="field-column">
                    <label for="additionalKmDefault">Recommended</label>
                    <input id="additionalKmDefault" data-testid="additional-km-default" pInputText type="number" min="0"
                        [(ngModel)]="additionalKmDefault" />
                </div>
                <div class="field-column">
                    <label for="additionalKmMax">Maximum</label>
                    <input id="additionalKmMax" data-testid="additional-km-max" pInputText type="number" min="0"
                        [(ngModel)]="additionalKmMax" />
                </div>
            </div>
        </p-card>

        <p-card header="Change reason (optional)" styleClass="settings-card">
            <div class="field-column">
                <label for="changeReason">Why are you changing these values?</label>
                <input id="changeReason" data-testid="rate-policy-change-reason" pInputText type="text"
                    maxlength="200" [(ngModel)]="changeReason" placeholder="e.g. Adjust for Santiago launch" />
            </div>
        </p-card>

        <p class="validation-error" data-testid="rate-policy-validation-error" *ngIf="validationError">
            {{ validationError }}
        </p>

        <div class="actions-row">
            <button pButton type="button" label="Refresh" icon="pi pi-refresh" class="p-button-outlined"
                data-testid="rate-policy-refresh" [disabled]="isSaving" (click)="loadPolicy()"></button>
            <button pButton type="button" label="Save policy" icon="pi pi-save"
                data-testid="rate-policy-save" [loading]="isSaving" [disabled]="!!validationError"
                (click)="save()"></button>
        </div>
    </ng-container>
</div>
